import Phaser from 'phaser'

const eventsController = new Phaser.Events.EventEmitter();

export default eventsController